import { useMutation } from '@tanstack/react-query';
import { Bill, BillReinstateParameters, useRepositoryRegistry } from '@mews-commander/data-access';

interface UseBillReinstateParams {
    onSuccess: (bill: Bill) => void;
}

export const useBillReinstate = ({ onSuccess }: UseBillReinstateParams) => {
    const { bills } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (params: BillReinstateParameters) => bills.reinstate(params),
        onSuccess,
    });
};
